import React, { Context, createContext, useCallback, useMemo, useState } from 'react';

import { mockMyPermissions } from '../../apis/graphql/user/mock';
import { isDemoEnvironment } from '../../constants/global';
import { defaultGlobalPermissions } from './constants';
import { GlobalPermissions } from './types';

const GlobalGlobalPermissionsContext: Context<GlobalPermissions> = createContext(
  isDemoEnvironment ? mockMyPermissions : defaultGlobalPermissions
);

export type GlobalPermissionsContainerProps = {
  children: React.ReactNode;
};

export const GlobalPermissionsContainer = ({ children }: GlobalPermissionsContainerProps): JSX.Element => {
  const [contextValues, setContextValues] = useState<GlobalPermissions>(defaultGlobalPermissions);

  const updateGlobalPermissions = useCallback((values: GlobalPermissions): void => {
    setContextValues(values);
  }, []);

  const contextValue = useMemo(
    () => ({ ...contextValues, updateGlobalPermissions }),
    [contextValues, updateGlobalPermissions]
  );

  return (
    <GlobalGlobalPermissionsContext.Provider value={contextValue}>{children}</GlobalGlobalPermissionsContext.Provider>
  );
};

export default GlobalGlobalPermissionsContext;
